import Nullstack from 'nullstack';
export default function IconTemperatureFahrenheit({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-temperature-fahrenheit",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "6",
    cy: "8",
    r: "2"
  }), "   ", Nullstack.element("line", {
    x1: "13",
    y1: "12",
    x2: "18",
    y2: "12"
  }), "   ", Nullstack.element("path", {
    d: "M20 6h-6a1 1 0 0 0 -1 1v11"
  }), " ");
}